export const NAVIGATION_METHODS = {
  LOBBY: 'lobby',
  URL: 'url',
  POPUP: 'popup',
  TAB: 'tab',
  REPLACE: 'replace',
  POST: 'post',
} as const;

export type NavigationMethodKey = keyof typeof NAVIGATION_METHODS

export type NavigationMethod = typeof NAVIGATION_METHODS[NavigationMethodKey];
